import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";

import {
    SpsContentRowColComponent,
    SpsContentRowComponent,
    SpsContentRowExpansionComponent,
} from "../components/index";

@NgModule({
    imports: [CommonModule],
    declarations: [
        SpsContentRowColComponent,
        SpsContentRowComponent,
        SpsContentRowExpansionComponent
    ],
    exports: [
        SpsContentRowColComponent,
        SpsContentRowComponent,
        SpsContentRowExpansionComponent
    ]
})
export class SpsContentRowModule {}
